<template>
  <div class="special-column">
    <div class="special-column-title">
      <h1>项目专栏</h1>
    </div>
    <div class="special-column-content">
      <!-- 第一栏项目 -->
      <specialColumn :itemData="itemDataUI" categoryTitle="UI设计" />
      <!-- 第二栏项目 -->
      <specialColumn :itemData="itemDataOnline" categoryTitle="电商设计" />
      <!-- 第三栏项目 -->
      <specialColumn :itemData="itemDataBrand" categoryTitle="平面设计" />
      <!-- 第四屏三维设计 -->
      <specialColumn :itemData="itemDataThree" categoryTitle="三维设计" />
    </div>
  </div>
</template>

<script>
import specialColumn from "./commonProject"
import { Contents } from "../../../../../gqlapi/Contents.js"

export default {
  components: {
    specialColumn
  },
  data () {
    return {
      itemDataUI: [],
      itemDataOnline: [],
      itemDataBrand: [],
      itemDataThree: []
    }
  },
  created () {
    this.getList("6")
  },
  methods: {
    getList (ids) {
      // this.$apollo.query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true,
      //     },
      //   })
      this.$axios.post('/api',{
            operationName: "Contents",
            variables:{
                subjectID: ids,
                isPublish: true,
            },
            query: Contents
        }).then((res) => {
          this.itemData = res.data.data.pContents
          const isIdsObj = {
            "11": "black",
            "9": "suyun",
            "6": "zhiwei",
            "13": "zhiniugu",
            "17": "saas",
            "19": "ihrm",
            "15": "likede",
            "20": "money",
            "5": "health",
            "8": "ice",
            "22": "zhihui",
            "21": "juhe",
            "1": "buy",
            "3": "chong"
          }
          this.itemData = this.itemData.map((obj) => ({ ...obj, src: isIdsObj[obj.id] }))
          this.itemDataUI = this.filterFn(this.itemData)
          this.itemDataOnline = this.filterFn(this.itemData, "13")
          this.itemDataBrand = this.filterFn(this.itemData, "14")
          this.itemDataThree = this.filterFn(this.itemData, "15")
        })
        .catch(() => {
        })
    },
    filterFn (list = [], type = '12') {
      let commonList = []
      if (list.length <= 0) return
      commonList = list.filter((item) => {
        return item.trade.id === type
      })
      return commonList
    }
  }
}
</script>

<style lang="scss" scoped>
  .special-column {
    width: 100%;
    min-width: 1200px;
    height: auto;
    background: url("../designImg/back-2x.jpg") no-repeat;
    background-size: 100% 100%;
    // height: 2320px;
    background-color: #fff;
    margin: 0 auto;
    padding-bottom: 20px;
    .special-column-title {
      // padding-top: 76px;
      padding-top: 49px;
      padding-bottom:49px;
      margin: 0 auto;
      min-width: 1200px;
      background-color: #fff;
      h1 {
        font-size: 36px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 38px;
      }
    }
  }
</style>